<template>
  <span>
    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 1"
      :src="require('@/assets/img/mapa/COM/COM-A-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 5"
      :src="require('@/assets/img/mapa/COM/COM-A-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 10"
      :src="require('@/assets/img/mapa/COM/COM-A-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 15"
      :src="require('@/assets/img/mapa/COM/COM-A-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 20"
      :src="require('@/assets/img/mapa/COM/COM-A-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 25"
      :src="require('@/assets/img/mapa/COM/COM-A-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 30"
      :src="require('@/assets/img/mapa/COM/COM-A-3-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 35"
      :src="require('@/assets/img/mapa/COM/COM-A-3-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 40"
      :src="require('@/assets/img/mapa/COM/COM-A-3-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 45"
      :src="require('@/assets/img/mapa/COM/COM-B-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 50"
      :src="require('@/assets/img/mapa/COM/COM-B-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 55"
      :src="require('@/assets/img/mapa/COM/COM-B-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 65"
      :src="require('@/assets/img/mapa/COM/COM-B-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 70"
      :src="require('@/assets/img/mapa/COM/COM-B-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 75"
      :src="require('@/assets/img/mapa/COM/COM-B-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 80"
      :src="require('@/assets/img/mapa/COM/COM-i-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 85"
      :src="require('@/assets/img/mapa/COM/COM-i-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 90"
      :src="require('@/assets/img/mapa/COM/COM-i-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 95"
      :src="require('@/assets/img/mapa/COM/COM-i-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 95"
      :src="require('@/assets/img/mapa/COM/COM-i-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 95"
      :src="require('@/assets/img/mapa/COM/COM-i-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>
  </span>
</template>

<script>
export default {
  props: {
    perguntaObj: { type: Object, required: true }
  }
}
</script>
